import React, { Component } from 'react';
import TableNew from '../../../../_components/common/TableNew';
import Settings from '../../../../_components/common/SettingsHeader';
import ModalNew from '../../../../_components/common/ModalNew';
import { sellerActions, countryListActions } from '../../../../_actions';
import { connect } from 'react-redux';
import { formData } from '../formData';
import './SellerTable.css';

class SellerTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sellers: '',
            modal: false,
            sortType: false,
            addSellerState: false
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(countryListActions.getCountries());
    }


    filterData(data) {
        this.setState({
            sellers: data
        });
    }

    toggleModal(showModal) {
        this.setState({
            addSellerState: showModal
        });
    }

    compareBy(key) {

        if (this.state.sortType == true) {
            return function (a, b) {

                if (a[key] !== null && b[key] !== null) {
                    if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
                    if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
                    return 0;
                }

            };
        }

        if (this.state.sortType == false) {
            return function (a, b) {
                if (a[key] !== null && b[key] !== null) {

                    if (a[key].toLowerCase() > b[key].toLowerCase()) return -1;
                    if (a[key].toLowerCase() < b[key].toLowerCase()) return 1;
                    return 0;
                }
            };
        }
    }


    sortBy(columnKey, type) {
        this.setState({ sortType: type })
        let arrayCopy = this.state.sellers === '' ? this.props.sellers : this.state.sellers;
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ sellers: arrayCopy });
    }

    actionSelected(data) {

        this.props.dispatch(sellerActions.addData(data.sellerData))
    }

    resetData(data) {
        data.value = '';
        if (data.validation.required === true) {
            data.valid = false;
        }
    }

    toggleAddSellerModal(showModal) {

        this.setState({
            addSellerState: showModal
        })

        formData.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    toggleEntireAddSellerModal(showModal) {
        this.setState({
            addSellerState: showModal
        })
    }

    render() {
        const { heading, loading, sellers } = this.props;

        const filteredData = this.state.sellers === '' ? sellers : this.state.sellers;

        const columns = [
            {
                id: 1,
                name: 'Name',
                key: 'seller_name',
                sort: true,
                link: 'sellers/'
            },
            {
                id: 2,
                name: 'Code',
                key: 'seller_code',
                sort: true,
                link: ''
            },
            {
                id: 3,
                name: 'City',
                key: 'city',
                sort: true,
                link: ''
            },
            {
                id: 4,
                name: 'Country',
                key: 'country__country_name',
                sort: true,
                link: ''
            }
        ];

        const { countries } = this.props;

        formData.map(function (element) {
            if (element.key === 'country') {
                element.elementConfig.options = countries;
            }
        });

        let buttonDataProp = [
            {
                id: 1,
                heading: "ADD A NEW SELLER",

                toggler: this.toggleAddSellerModal.bind(this),
                togglerModal: this.state.addSellerState
            }
        ]

        return (
            <div>
                <div className="bg-green rounded-top position-relative ">
                    <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> {heading} </p>
                    {
                        loading &&
                        <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position " ></i>
                    }
                </div>
                {
                    !loading &&
                    <div className="animation-fade-in">
                        <Settings
                            columns={columns}
                            sellers={sellers}
                            view={this.filterData.bind(this)}
                            buttonData={buttonDataProp}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.addSellerState}

                            filter={true}
                        />

                        <TableNew
                            data={filteredData}
                            columns={columns}
                            showSlNo="true"
                            sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                            sortType={this.state.sortType}
                        />


                        {
                            this.state.addSellerState &&
                            <ModalNew
                                selectKey={['id', 'id']}
                                selects={['seller_name', 'country_name']}
                                modalName="addSeller"
                                heading="Seller details"
                                showModal={this.state.addSellerState}
                                formData={formData}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireAddSellerModal.bind(this)}
                            />
                        }
                    </div>
                }
            </div>
        );
    }
}


function mapStateToProps(state) {
    const { loading } = state.countries;
    const { error } = state.countries;
    const countries = (!loading && !error) ? state.countries.countries : '';
    return {
        loading,
        countries
    };
}

export default connect(mapStateToProps)(SellerTable);


// WEBPACK FOOTER //
// ./src/_pages/Admin/Sellers/Components/SellerTable.jsx